import React, { useEffect, useMemo, useState } from 'react';

import { Tooltip, Select } from 'antd';
import { Link } from 'react-router-dom';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useGetAllPeriodicitiesQuery } from 'src/redux/services/centralApi';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import type {
	IPeriodicitySelectComponent
} from 'src/pages/observers/components/PeriodicitySelect/types';

export default function PeriodicitySelect(
	{
		defaultPeriodicity,
		onPeriodicityChange,
	}: IPeriodicitySelectComponent
) {
	const {
		data: periodicitiesData,
		isLoading: isLoadingPeriodicities,
	} = useGetAllPeriodicitiesQuery();

	const [ periodicity, setPeriodicity, ] = useState<string | undefined>(defaultPeriodicity);

	const periodicitiesOptions = useMemo(() => {
		if (!periodicitiesData) return [];

		return periodicitiesData.map((periodicity) => ({
			label: periodicity.alias,
			value: periodicity.periodicity_id,
		}));
	}, [ periodicitiesData, ]);

	useEffect(() => {
		if(periodicity && onPeriodicityChange)
			onPeriodicityChange(periodicity);
	}, [ periodicity, ]);

	return (
		<FormItem>
			<FormLabel>
                * Periodicidade:
				{periodicitiesOptions.length === 0 && (
					<Tooltip
						title={
							<>
								{'Configure uma periodicidade '}
								<Link
									to={`${process.env.REACT_APP_PUBLIC_URL}/cron/adicionar`}
								>
                                    aqui
								</Link>
								{' para ter acesso a essa funcionalidade.'}
							</>
						}
					>
						<QuestionCircleOutlined
							style={{
								color: 'rgba(0,0,0,0.45)',
								cursor: 'help',
							}}
						/>
					</Tooltip>
				)}
			</FormLabel>
			<Select
				placeholder='Periodicidade'
				value={periodicity}
				onChange={(value) => setPeriodicity(value)}
				options={periodicitiesOptions}
				loading={isLoadingPeriodicities}
				disabled={periodicitiesOptions.length === 0}
			/>
		</FormItem>
	);
}
